import { buildPermissionCategories, buildRolePresets } from '@/@types/TeamMember';
import { TeamActionsService, type ISellerAreaAction } from '@/services/team-actions.service';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

const EMPTY_ACTIONS: ISellerAreaAction[] = [];

export function useTeamActions() {
  const { data: actions = EMPTY_ACTIONS, isLoading } = useQuery({
    queryKey: ['team-actions'],
    queryFn: TeamActionsService.getActions,
    staleTime: 1000 * 60 * 30,
  });

  const groupedActions = useMemo(
    () => TeamActionsService.groupByCategory(actions),
    [actions],
  );

  const categories = useMemo(
    () => buildPermissionCategories(groupedActions),
    [groupedActions],
  );

  const rolePresets = useMemo(
    () => buildRolePresets(categories),
    [categories],
  );

  const getEmptyPermissions = (): Record<string, string[]> => {
    const result: Record<string, string[]> = {};
    for (const category of Object.keys(categories)) {
      result[category] = [];
    }
    return result;
  };

  return {
    actions,
    categories,
    rolePresets,
    getEmptyPermissions,
    isLoading,
  };
}
